export const COLORS = [
  '#A3D696',
  '#FF8181',
  '#6C83FF',
  // '#EFF2FC',
  '#FF974C'
]

export const removeLocalStorage = () => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('error')
  localStorage.removeItem('refresh_token_api')
  localStorage.removeItem('isPCverified')
  localStorage.removeItem('gwuid')
  localStorage.removeItem('email')
  localStorage.removeItem('mac')
}
